import { computed, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { toSignal } from "@angular/core/rxjs-interop";
import { WindowHelperService } from "../../../shared/services/window-helper.service";

@Injectable({
  providedIn: "root",
})
export class DisplayService {
  private _showBars$ = new BehaviorSubject<boolean>(true);

  isMobile = toSignal(WindowHelperService.isMobile());
  isUwide = toSignal(WindowHelperService.isUwide());
  isLd = toSignal(WindowHelperService.isLd());
  isMd = toSignal(WindowHelperService.isMd());
  isDesktop = computed(() => !this.isMobile() && !this.isLd());

  get showBars$(): Observable<boolean> {
    return this._showBars$.asObservable();
  }

  constructor() {}

  setShowBars(b: boolean) {
    this._showBars$.next(b);
  }
}
